module.exports = __webpack_public_path__ + "static/media/glue.41f81294.png";